import Page from 'attendee/theme/Page'
import React from 'react'
import UnderTitlearrow from 'assets/icons/svg/UnderTitlearrow'
import {EventListItem} from 'attendee/EventListItem'
import {useAttendeeEventsList} from 'attendee/providers/AttendeeEventsListProvider'
import {Helmet} from 'react-helmet'
import {DEFAULT_OG_IMAGE, SITE_ORIGIN} from 'seo/siteMeta'
import {useI18n} from 'i18n/I18nContext'
import {withLocalePath} from 'i18n/localePaths'
import {routes} from 'routes/routes'

export function Search() {
  const {events} = useAttendeeEventsList()
  const {locale, t} = useI18n()
  const pageUrl = `${SITE_ORIGIN}${withLocalePath(locale, routes.search)}`

  return (
    <Page>
      <>
        <Helmet>
          <title>{t('searchPage.metaTitle')}</title>
          <meta name="description" content={t('searchPage.metaDescription')} />
          <link rel="canonical" href={pageUrl} />
          <meta property="og:title" content={t('searchPage.ogTitle')} />
          <meta
            property="og:description"
            content={t('searchPage.ogDescription')}
          />
          <meta property="og:url" content={pageUrl} />
          <meta property="og:image" content={DEFAULT_OG_IMAGE} />
          <meta property="og:image:secure_url" content={DEFAULT_OG_IMAGE} />
          <meta property="og:image:type" content="image/jpeg" />
          <meta property="og:image:width" content="1200" />
          <meta property="og:image:height" content="630" />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content={t('searchPage.ogTitle')} />
          <meta
            name="twitter:description"
            content={t('searchPage.ogDescription')}
          />
          <meta name="twitter:image" content={DEFAULT_OG_IMAGE} />
        </Helmet>
        <section className="event__schedule-area dark_light_class pt-55 pb-55">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-xxl-7 col-xl-7 col-lg-6">
                <div className="section__title-wrapper is-left mb-50">
                  <span className="section__back-title">
                    {t('searchPage.backTitle')}
                  </span>
                  <span className="section__subtitle">
                    {t('searchPage.subtitle')}
                  </span>
                  <h2 className="section__title">
                    {t('searchPage.titleBefore')}{' '}
                    <span className="text__highlight">
                      {' '}
                      {t('searchPage.titleHighlight')}
                      <UnderTitlearrow />
                    </span>
                  </h2>
                </div>
              </div>
            </div>

            <div className="row">
              {events.length > 0 &&
                events.map((event, index) => (
                  <EventListItem event={event} index={index} />
                ))}
              {events.length === 0 && (
                <center>
                  <h4>{t('searchPage.empty')}</h4>
                </center>
              )}
            </div>
          </div>
        </section>
      </>
    </Page>
  )
}
